import { buildProps } from '../../../utils/props.mjs';
import '../../tooltip/index.mjs';
import { useTooltipContentProps } from '../../tooltip/src/tooltip2.mjs';

const usePopoverProps = {
  content: useTooltipContentProps.content,
  popperStyle: useTooltipContentProps.popperStyle,
  popperClass: useTooltipContentProps.popperClass,
  enterable: {
    ...useTooltipContentProps.enterable,
    default: true
  },
  effect: {
    ...useTooltipContentProps.effect,
    default: "light"
  },
  ...buildProps({
    title: String,
    hideAfter: {
      type: Number,
      default: 200
    },
    width: {
      type: [String, Number],
      default: 150
    }
  })
};

export { usePopoverProps };
//# sourceMappingURL=popover.mjs.map
